<script>
	import {translations} from "../../../stores/translations";

	export let provider;
	let authenticatingWithSSO = false;
	export let id;

	function loginWithSingleSignOn(ssoDriver){
		authenticatingWithSSO = true;
		window.location.href = `/auth/sso/${ssoDriver}/redirect`;
	}
</script>

<button {id}
		type="button"
		role="link"
		class="relative text-white w-full inline-flex justify-center items-center px-2 py-1 border-white border rounded { authenticatingWithSSO ? 'opacity-50' : 'hover:bg-white/10'} {$$props.class ?? ''}"
		disabled={authenticatingWithSSO}
		on:click={() => loginWithSingleSignOn(provider)}
>
	<img alt="" class="spinner w-5 h-5 absolute left-2" class:opacity-0={!authenticatingWithSSO}
		 src="{$translations.login_preloader}">
	<slot />
</button>
